/*!

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)
* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Card, CardTitle, CardHeader, CardBody, Row, Col } from "reactstrap";	// reactstrap components


class Downloads extends React.Component {

	render() {
		return (
		  <>
			<div className="content">

			<h5 className="title"> Downloads </h5>

			  <Row>

				<Col md="6">
				  <Card>
					<CardHeader>
					  <CardTitle tag="h5"> Town Tag </CardTitle>
					  <p className="category">
					  	Play Town Tag
					  </p>
					</CardHeader>
					<CardBody>
						<div className="text-center">
					  </div>
						<div>
							<a href="https://towntag.lol/towntag.apk"> Latest version of Town Tag for <b>Android</b> </a>
							<br />
							<br />
							<u>
							Instructions for installing Town Tag for <b>iOS</b>
							</u>
							<ul>
							<li> Send me the email associated with your iPhone or iPad </li>
							<li> Install Testflight from the App Store </li>
							<li> Click on the link sent in an invitation email from your iPhone or iPad </li>
							<li> Open Testflight to Install or Update Town Tag </li>
							</ul>
						</div>
					</CardBody>
				  </Card>
				</Col>

				<Col md="6">
				  <Card>
					<CardHeader>
					  <CardTitle tag="h5"> WorkClock </CardTitle>
					  <p className="category">
					  	Start / Stop your timecard on various projecs
					  </p>
					</CardHeader>
					<CardBody>
						<div className="text-center">
							<a href="https://beccue.com/Workclock-latest.php"> Latest version of WorkClock for <b>Windows</b> </a>
							<br />
							<small> Contact me if a Mac version would be useful to you. </small>
							<br />
							<a href="https://peregrine-llc.com/downloads/workclock"> Latest version of WorkClock for <b>Linux</b> </a>
							<br />
							<br />
							<a href="https://lnk2.click/wc">
								 Latest version of WorkClock for <b>Android</b>
								<br />
								<img alt="qrcode_wc" className="p-3" width="375px" src="/qrcode-workclock.jpg" />
							</a>
					  </div>
					</CardBody>
				  </Card>
				</Col>

				<Col md="6">
				  <Card>
					<CardHeader>
					  <CardTitle tag="h5"> BatteryWatch </CardTitle>
					  <p className="category">
					  	Start / Stop the power supply for your laptop
					  </p>
					</CardHeader>
					<CardBody>
					  <div className="typography-line">
						<a href="https://beccue.com/BatteryWatch-latest.php"> Latest version of BatteryWatch for <b>Windows</b> </a>
						<br />
						<a href="http://peregrine-llc.com/downloads/batterywatch.dmg"> Latest version of BatteryWatch for <b>Mac</b> </a>
						<br />
						<a href="http://peregrine-llc.com/downloads/batterywatch"> Latest version of BatteryWatch for <b>Linux</b> </a>

					  </div>
					</CardBody>
				  </Card>
				</Col>
			  </Row>

			  <Row>
			  </Row>

			</div>
		  </>
		);
	}
}

export default Downloads;
